import { render, staticRenderFns } from "./NeedEditOpportunities.vue?vue&type=template&id=c5edf212&scoped=true&"
import script from "./NeedEditOpportunities.vue?vue&type=script&lang=js&"
export * from "./NeedEditOpportunities.vue?vue&type=script&lang=js&"
import style0 from "./NeedEditOpportunities.vue?vue&type=style&index=0&id=c5edf212&prod&lang=css&"
import style1 from "./NeedEditOpportunities.vue?vue&type=style&index=1&id=c5edf212&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5edf212",
  null
  
)

export default component.exports